import { CATEGORY_TYPES } from "../config";
import {backendRequest} from "../utils/backend";

export const getCategoriesByType = (categoryType = CATEGORY_TYPES.PRODUCT) => {
    return backendRequest.get(`/category?categoryType=${categoryType}`);
};

export const getVendorCategoriesById = (vendorId) => {
    return backendRequest.get(`/category/vendor/${vendorId}`)
};